// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__10NMz","productName":"Table_productName__3gS9T"};